import React, { useRef } from "react";
import MainLayout from "../layout/main-layout";
import ReactJsHeadSection from "../Components/react-js/react-js-head-section";
import ReactJsBenefits from "../Components/react-js/react-js-benefits";
import ReactJsProcess from "../Components/react-js/react-js-process";
import WhyChooseReact from "../Components/react-js/why-choose-react";
import ReactContactSection from "../Components/react-js/react-contact-section";
import MetaTags from "../utils/meta-tags";

function ReactJs() {
    const contactRef = useRef<HTMLDivElement>(null);
  
    const handleScrollToContact = () => {
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  
  return (
    <div>
      <MetaTags
        title="React JS Development Company | Frontend Experts | SoftCoding Solutions"
        description="Hire experienced React.js developers to build fast, scalable web apps. We craft high-performance UIs for startups and enterprises worldwide."
        canonical="https://softcodingsolutions.com/react-js-development-company"
        og={{
          title: "React JS Development Services | SoftCoding Solutions",
          description:
            "Partner with our React experts to build lightning-fast web applications. UI-focused, scalable, and easy to maintain.",
          url: "https://softcodingsolutions.com/react-js-development-company",
          type: "website",
          site_name: "SoftCoding Solutions",
          image:
            "https://softcodingsolutions.com/static/media/logo%20company.23b84ead7179e68dfe2f.png",
          imageWidth: "1200",
          imageHeight: "630",
        }}
      />
      <MainLayout>
        <ReactJsHeadSection onScroll={handleScrollToContact} />
        <ReactJsBenefits />
        <ReactJsProcess />
        <WhyChooseReact />
        <ReactContactSection contactRef={contactRef} />
      </MainLayout>
    </div>
  );
}

export default ReactJs;
